import { useContext } from 'react';

import type { IContext } from './Context';
import Context from './Context';

export { default as Provider } from './Provider';

export type Config = IContext;

export function useConfig(): IContext {
  return useContext(Context);
}
